import Glide from '@glidejs/glide'

export default class NewsSection {
    
    static get selector() {
        return '.newsSection';
    }

    constructor(el) {
        new Glide('.glide', {
            type: 'carousel',
            startAt: 0,
            perView: 3,
            gap: 30,
            breakpoints: {
                600: {
                   perView: 1,

                },
                900: {
                    perView: 2,
                }
            }
        }).mount()
    }





}